import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LegalPage.css';

export default function TermsPage() {
  const navigate = useNavigate();

  return (
    <div className="legal-root">
      <header className="legal-header">
        <button className="legal-back" onClick={() => navigate('/')}>← Επιστροφή</button>
        <div className="legal-logo">✂ SalonBook</div>
      </header>

      <div className="legal-content">
        <div className="legal-hero">
          <div className="legal-badge">Νομικά</div>
          <h1>Όροι Χρήσης</h1>
          <p>Τελευταία ενημέρωση: Μάιος 2026</p>
        </div>

        <div className="legal-body">

          <section>
            <h2>1. Αποδοχή όρων</h2>
            <p>Με τη χρήση της πλατφόρμας SalonBook αποδέχεστε τους παρόντες Όρους Χρήσης. Αν δεν συμφωνείτε, παρακαλούμε να μην χρησιμοποιείτε την υπηρεσία.</p>
          </section>

          <section>
            <h2>2. Περιγραφή υπηρεσίας</h2>
            <p>Η SalonBook παρέχει λογισμικό διαχείρισης κρατήσεων για κομμωτήρια και χώρους ομορφιάς. Η υπηρεσία περιλαμβάνει:</p>
            <ul>
              <li>Ψηφιακό ημερολόγιο κρατήσεων</li>
              <li>Διαχείριση πελατολογίου</li>
              <li>Διαχείριση υπηρεσιών και προσωπικού</li>
              <li>Στατιστικά και αναφορές</li>
              <li>AI-powered κράτηση μέσω τηλεφώνου</li>
            </ul>
          </section>

          <section>
            <h2>3. Λογαριασμός χρήστη</h2>
            <ul>
              <li>Είστε υπεύθυνοι για τη διατήρηση της ασφάλειας του λογαριασμού σας</li>
              <li>Δεν επιτρέπεται η κοινοποίηση των στοιχείων πρόσβασής σας</li>
              <li>Πρέπει να μας ενημερώσετε άμεσα για οποιαδήποτε μη εξουσιοδοτημένη χρήση</li>
              <li>Είστε υπεύθυνοι για όλες τις ενέργειες που γίνονται μέσω του λογαριασμού σας</li>
            </ul>
          </section>

          <section>
            <h2>4. Αποδεκτή χρήση</h2>
            <p>Απαγορεύεται:</p>
            <ul>
              <li>Χρήση της πλατφόρμας για παράνομους σκοπούς</li>
              <li>Μεταφόρτωση κακόβουλου λογισμικού</li>
              <li>Προσπάθεια μη εξουσιοδοτημένης πρόσβασης σε συστήματα</li>
              <li>Spam ή μαζική αποστολή μηνυμάτων</li>
              <li>Αντιγραφή ή αναδιανομή του λογισμικού</li>
            </ul>
          </section>

          <section>
            <h2>5. Συνδρομή και πληρωμές</h2>
            <ul>
              <li>Η τιμολόγηση γίνεται μηνιαία ή ετήσια βάσει του επιλεγμένου πλάνου</li>
              <li>Οι πληρωμές δεν επιστρέφονται εκτός αν ορίζεται διαφορετικά</li>
              <li>Διατηρούμε το δικαίωμα αλλαγής τιμών με 30 ημέρες προειδοποίηση</li>
              <li>Σε περίπτωση μη πληρωμής, ο λογαριασμός μπορεί να απενεργοποιηθεί</li>
            </ul>
          </section>

          <section>
            <h2>6. Δεδομένα και ιδιοκτησία</h2>
            <ul>
              <li>Τα δεδομένα των πελατών σας ανήκουν αποκλειστικά σε εσάς</li>
              <li>Η SalonBook δεν διεκδικεί δικαιώματα ιδιοκτησίας επί των δεδομένων σας</li>
              <li>Μπορείτε να εξάγετε τα δεδομένα σας οποτεδήποτε</li>
              <li>Το λογισμικό και η τεχνολογία SalonBook ανήκουν στην εταιρεία</li>
            </ul>
          </section>

          <section>
            <h2>7. Διαθεσιμότητα υπηρεσίας</h2>
            <p>Στόχος μας είναι διαθεσιμότητα 99.9% (uptime). Ωστόσο δεν εγγυόμαστε αδιάλειπτη λειτουργία. Προγραμματισμένη συντήρηση θα ανακοινώνεται εκ των προτέρων.</p>
          </section>

          <section>
            <h2>8. Περιορισμός ευθύνης</h2>
            <p>Η SalonBook δεν φέρει ευθύνη για:</p>
            <ul>
              <li>Έμμεσες ή αποθετικές ζημίες</li>
              <li>Απώλεια εσόδων λόγω διακοπής υπηρεσίας</li>
              <li>Ενέργειες τρίτων μερών</li>
            </ul>
            <p>Η συνολική ευθύνη μας δεν υπερβαίνει το ποσό που καταβλήθηκε τους τελευταίους 3 μήνες.</p>
          </section>

          <section>
            <h2>9. Τερματισμός</h2>
            <p>Μπορείτε να τερματίσετε τον λογαριασμό σας οποτεδήποτε. Διατηρούμε το δικαίωμα τερματισμού λογαριασμών που παραβιάζουν τους παρόντες όρους.</p>
          </section>

          <section>
            <h2>10. Εφαρμοστέο δίκαιο</h2>
            <p>Οι παρόντες όροι διέπονται από το Ελληνικό δίκαιο. Αρμόδια δικαστήρια είναι τα δικαστήρια της Αθήνας.</p>
          </section>

          <section>
            <h2>11. Επικοινωνία</h2>
            <p>Για ερωτήσεις σχετικά με τους Όρους Χρήσης: <a href="mailto:legal@salonbook.gr">legal@salonbook.gr</a></p>
          </section>

        </div>
      </div>

      <footer className="legal-footer">
        <span>© {new Date().getFullYear()} SalonBook. Όλα τα δικαιώματα διατηρούνται.</span>
        <div className="legal-footer-links">
          <a href="/privacy">Πολιτική Απορρήτου</a>
          <a href="/terms">Όροι Χρήσης</a>
          <a href="/gdpr">GDPR</a>
        </div>
      </footer>
    </div>
  );
}